<template>
  <div class="row">
    <div v-for="(entries, content_type) in release.content" :key="content_type" class="col-12 col-md-6 content-types">
      <basic-portlet :title="getContentTypeLabel(content_type)" :icon="getContentTypeIcon(content_type)" :bordered="true">
        <ul class="list-group list-group-flush">
          <li v-for="(entry, index) in entries" :key="`${content_type}_${index}`" class="list-group-item">
            <div v-sanitise="entry.description" class="entry-content honour-whitespace" />
          </li>
        </ul>
      </basic-portlet>
    </div>
  </div>
</template>
<script>
import BasicPortlet from "VueComponents/BasicPortlet";
export default {
  components: { BasicPortlet },
  props: {
    release: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getContentTypeLabel(content_type) {
      const string = content_type.replace("_", " ");
      return string.replace(/\w\S*/g, w => (w.replace(/^\w/, c => c.toUpperCase())));
    },
    getContentTypeIcon(content_type) {
      if (content_type === 'bug_fixes') {
        return 'fa fa-bug';
      }

      if (content_type === 'features') {
        return 'fa fa-plus';
      }

      if (content_type === 'enhancements') {
        return 'fa fa-bolt';
      }

      return 'fa fa-bullhorn';
    },
  },
};
</script>

<style lang="scss" scoped>
  .honour-whitespace {
    white-space:pre-wrap;
  }
  .content-types {
    .kt-portlet__head-title {
      text-transform: capitalize;
    }
  }

</style>
